<template>
  <div class="w-full flex flex-col">
    <div
      class="flex items-center justify-between relative flex-col laptop:flex-row"
    >
      <h1 class="font-bold text-xl mb-2 laptop:mb-0">مشخصات مشتری</h1>
      <div class="laptop:absolute laptop:w-full">
        <div
          class="flex w-fit h-9 mx-auto text-sm rounded-lg overflow-hidden border border-blue-700"
        >
          <div
            @click="clieckedTab(item.id)"
            v-for="item in titleTab"
            :key="item.id"
            class="h-full w-18 tablet:w-20 laptop:w-32 text-center flex justify-center items-center"
            :class="
              tabItem === item.id
                ? 'bg-blue-700 text-white'
                : 'bg-white cursor-pointer'
            "
          >
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
    <div class="mt-6 text-sm">
      <template v-if="tabItem === 1">
        <h2 class="text-center laptop:text-right">
          لطفا جهت تکمیل درخواست خود، اطلاعات زیر را وارد کرده و روی دکمه
          "دریافت کد تایید" کلیک کنید.
        </h2>
        <Form
          class="w-full mt-10"
          :validation-schema="schema1"
          :initial-values="initialValues1"
          @submit="handleSubmit"
        >
          <div
            class="grid gap-x-10 items-center justify-between grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 flex-wrap"
          >
            <BaseInput
              name="agentFirstname"
              type="text"
              placeholder="نام نماینده شرکت  "
              require
            />
            <BaseInput
              name="agentLastname"
              type="text"
              placeholder="نام خانوادگی نماینده شرکت  "
              require
            />
            <BaseInput
              name="CompanyAgentNatCode"
              type="text"
              placeholder=" کد ملی نماینده شرکت"
              isNumber
            />
            <BaseInput
              name="CompanyAgentMobileNo"
              type="text"
              placeholder=" شماره موبایل نماینده شرکت"
              isNumber
              require
            />
            <BaseInput name="CompanyName" type="text" placeholder="نام شرکت " />
            <BaseInput
              name="CompanyShenaseMeli"
              type="text"
              placeholder=" شناسه ملی"
              isNumber
            />
            <BaseInput
              name="CompanyAddress"
              type="text"
              placeholder="آدرس شرکت "
            />
            <BaseInput
              name="CompanyPostalCode"
              type="text"
              placeholder=" کد پستی"
              isNumber
            />
            <BaseInputSelect name="ActivityTitle" :options="options" />
          </div>
          <div>
            <div class="flex items-start text-sm mt-3">
              <input
                id="terms"
                v-model="isTermsAccepted"
                type="checkbox"
                class="me-1 mt-1"
              />
              <span
                ><span
                  class="cursor-pointer text-blue-500"
                  @click.stop="isTermsModalShowed = true"
                  >قوانین و شرایط استفاده از خدمات نواتل</span
                >
                <label for="terms"> را مطالعه کرده و قبول دارم. </label>
              </span>
            </div>
            <div
              v-if="isSubmitedForm && !isTermsAccepted"
              class="text-red-500 text-xs mt-1 ms-1 h-16 font-bold"
            >
              <p class="font-12 mr-3">
                برای استفاده از خدمات نواتل، موافقت با قوانین الزامی است.
              </p>
            </div>
            <div v-else class="mt-1 h-16">
              <p></p>
            </div>
          </div>
          <div class="w-full laptop:max-w-[30%] float-left">
            <BaseButton
              :isLoading="isLoading"
              class="mt-2"
              isLean
              size="full"
              type="submit"
              text="دریافت کد تایید "
              @click="isSubmitedForm = true"
              id="oshop-verifyCode"
            />
          </div>
        </Form>
      </template>
      <template v-if="tabItem === 2">
        <div class="text-center laptop:text-right">
          لطفا جهت تکمیل درخواست خود، اطلاعات زیر را وارد کرده و روی دکمه
          "دریافت کد تایید" کلیک کنید.
        </div>
        <Form
          class="w-full mt-10"
          :validation-schema="schema2"
          :initial-values="initialValues2"
          @submit="handleSubmit"
        >
          <div
            class="grid gap-x-10 items-center justify-between grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 flex-wrap"
          >
            <BaseInput name="FName" type="text" placeholder="نام" require />
            <BaseInput
              name="LName"
              type="text"
              placeholder="نام خانوادگی"
              require
            />
            <BaseInput
              name="NatCode"
              type="text"
              placeholder="کد ملی "
              isNumber
            />
            <BaseInput
              name="MobileNo"
              type="text"
              placeholder="شماره موبایل"
              isNumber
              require
            />
            <BaseInput name="Email" type="text" placeholder="پست الکترونیک" />
            <BaseInput name="City" type="text" placeholder="شهر محل سکونت" />
          </div>
          <div>
            <div class="flex items-start text-sm mt-3">
              <input
                id="terms"
                v-model="isTermsAccepted"
                type="checkbox"
                class="me-1 mt-1"
              />
              <span
                ><span
                  class="cursor-pointer text-blue-500"
                  @click.stop="isTermsModalShowed = true"
                  >قوانین و شرایط استفاده از خدمات نواتل</span
                >
                <label for="terms"> را مطالعه کرده و قبول دارم. </label>
              </span>
            </div>
            <div
              v-if="isSubmitedForm && !isTermsAccepted"
              class="text-red-500 text-xs mt-1 ms-1 h-16 font-bold"
            >
              <p class="font-12 mr-3">
                برای استفاده از خدمات نواتل، موافقت با قوانین الزامی است.
              </p>
            </div>
            <div v-else class="mt-1 h-16">
              <p></p>
            </div>
          </div>
          <div class="w-full laptop:max-w-[30%] float-left">
            <BaseButton
              :isLoading="isLoading"
              class="mt-2"
              isLean
              size="full"
              type="submit"
              text="دریافت کد تایید "
              @click="isSubmitedForm = true"
              id="oshop-verifyCode"
            />
          </div>
        </Form>
      </template>
    </div>
    <SectionModalTerms
      :isShow="isTermsModalShowed"
      @close="isTermsModalShowed = false"
      @accept="acceptTerms"
    />
    <SectionModalOTP
      :isShow="isOTPModalShowed"
      :otpError="otpError"
      @close="isOTPModalShowed = false"
      @OTPConfirmed="verify"
      @retry="retryOTP"
    />
  </div>
</template>

<script setup>
import { object, string } from "yup";
import { Form } from "vee-validate";
const {
  validateFaChar,
  validateMobile,
  validateNationalCode,
  validateEmail,
  validateLength,
  fa2en,
} = useInputHelpers();
const { register, verifyOTP, resendOTP } = useOnlineShopping();
const { pageTitle } = useSendMail();

const props = defineProps({
  shoppingType: String,
  refer: String,
});
const emit = defineEmits(["goToNextStep"]);

const isTermsModalShowed = ref(false);
const isSubmitedForm = ref(false);
const isOTPModalShowed = ref(false);
const isLoading = ref(false);
const otpError = ref("");

const acceptTerms = () => {
  isTermsAccepted.value = true;
};

const isTermsAccepted = ref(true);

const goToNextStep = () => {
  emit("goToNextStep");
};

const titleTab = [
  { id: 1, title: "حقوقی" },
  { id: 2, title: "حقیقی" },
];
const tabItem = ref(1);

const clieckedTab = (id) => {
  tabItem.value = id;
  isSubmitedForm.value = false;
};

const options = [
  { value: 0, text: "حوزه فعالیت", isSelected: true },
  { value: "طراحی وب", text: "طراحی وب" },
  { value: "خدمات بیمه ای", text: "خدمات بیمه ای" },
  { value: "مشاوره", text: "مشاوره" },
  { value: "کوچینگ", text: "کوچینگ" },
  { value: "فروشگاه اینترنتی", text: "فروشگاه اینترنتی" },
  { value: "خرید و فروش کالا", text: "خرید و فروش کالا" },
  { value: "شرکت مهندسی بازرگانی", text: "شرکت مهندسی بازرگانی" },
  { value: "آرایشی و بهداشتی", text: "آرایشی و بهداشتی" },
  { value: "غذایی", text: "غذایی" },
  { value: "پوشاک", text: "پوشاک" },
  { value: "سایر", text: "سایر" },
];

const initialValues1 = {
  agentFirstname: "",
  agentLastname: "",
  CompanyAgentNatCode: "",
  CompanyAgentMobileNo: "",
  CompanyName: "",
  CompanyShenaseMeli: "",
  CompanyAddress: "",
  CompanyPostalCode: "",
  type: 2,
  ActivityTitle: 0,
};

const initialValues2 = {
  FName: "",
  LName: "",
  NatCode: "",
  MobileNo: "",
  Email: "",
  City: "",
  type: 1,
};

const schema1 = object({
  agentFirstname: string()
    .required("این فیلد نباید خالی باشد.")
    .test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
  agentLastname: string()
    .required("این فیلد نباید خالی باشد.")
    .test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
  CompanyAgentNatCode: string().test(
    "",
    "مقدار وارد شده معتبر نیست.",
    validateNationalCode
  ),
  CompanyAgentMobileNo: string()
    .required("این فیلد نباید خالی باشد.")
    .test("", "مقدار وارد شده معتبر نیست.", validateMobile),
  CompanyName: string().test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
  CompanyAddress: string().test(
    "",
    "مقدار وارد شده معتبر نیست.",
    validateFaChar
  ),
  CompanyShenaseMeli: string().test(
    "",
    "شناسه ملی معتبر نیست",
    function (item) {
      return item ? item.length == 0 || item.length == 11 : true;
    }
  ),
});

const schema2 = object({
  FName: string()
    .required("این فیلد نباید خالی باشد.")
    .test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
  LName: string()
    .required("این فیلد نباید خالی باشد.")
    .test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
  NatCode: string().test(
    "",
    "مقدار وارد شده معتبر نیست.",
    validateNationalCode
  ),
  MobileNo: string()
    .required("این فیلد نباید خالی باشد.")
    .test("", "مقدار وارد شده معتبر نیست.", validateMobile),
  Email: string().test("", "مقدار وارد شده معتبر نیست.", validateEmail),
  City: string().test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
});

const handleSubmit = async (form, { resetForm }) => {
  otpError.value = "";
  if (isTermsAccepted.value) {
    isLoading.value = true;
    form.refer = pageTitle(props.refer) || "";
    form.RegisterType = pageTitle(props.refer) || "";
    const { data, error } = await register({ body: form });
    isLoading.value = false;
    if (!error.value && data.value.msg === "1") {
      isOTPModalShowed.value = true;
      useState("token").value = data.value.token;
      // localStorage.setItem('token', data.value.token)
      localStorage.setItem(
        props.shoppingType,
        JSON.stringify({
          token: data.value.token,
          user_type: form.type,
        })
      );
      // useState('token',() => data.value.token)
    }
  }
};

const verify = async (number) => {
  const { data, error } = await verifyOTP({ body: { VerCode: fa2en(number) } });
  if (!error.value && data.value.msg != 2) {
    isOTPModalShowed.value = false;
    goToNextStep();
  } else {
    otpError.value = "کد وارد شده صحیح نیست.";
  }
};

const retryOTP = async () => {
  await resendOTP({ body: {} });
};
</script>
